import React, { useEffect } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import Aos from 'aos'
import { useNavigate } from 'react-router-dom'



function Services2() {
  const navigate = useNavigate();
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  return (
    <>
      <div className="main-div2">

        <Navbar />
        <div className='flex md:flex-row flex-col md:gap-0 gap-[20px] justify-between overflow-hidden items-center md:pt-[163px] pt-[100px]'>
          <div className='flex flex-col gap-[12px]'>
            <img data-aos="fade-down" src="/assets/services/item1.svg" className='relative left-[-70px] md:h-[88px] h-[70px] max-w-[445px] w-full' alt="" />
            <img data-aos="fade-up" src="/assets/services/item2.svg" className='relative left-[-70px]' alt="" />
          </div>
          <div className='flex gap-[16px] md:pl-0 pl-[20px] md:pr-[108px] pr-[20px] flex-wrap justify-center'>
            <div data-aos="flip-up" className='relative pb-[11px]'>
              <img src="/assets/services/item4.svg" alt="" />
              <button onClick={() => navigate("/lateralhirning")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] text-[24px] leading-[22px] text-[#FFFFFF] h-[50px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[198px]'>Lateral Hiring</button>
            </div>
            <div data-aos="flip-up" className='relative pb-[11px]'>
              <img src="/assets/services/item3.svg" alt="" />
              <button onClick={() => navigate("/train")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] text-[24px] leading-[22px] text-[#FFFFFF] h-[50px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[198px]'>Hire Train Depoy</button>
            </div>
          </div>
        </div>
        <div className='grid md:grid-cols-2 grid-cols-1 gap-[20px] mt-[16px] md:px-[100px] px-[20px] pb-[32px]'>
        <div className='flex flex-wrap items-center justify-center gap-[16px]'>
        <div data-aos="flip-up" className='relative pb-[11px]'>
              <img src="/assets/services/item5.svg" alt="" />
              <button onClick={() => navigate("/cloudlab")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] text-[24px] leading-[22px] text-[#FFFFFF] h-[50px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[198px]'>Cloud Labs</button>
            </div>
        <div data-aos="flip-up" className='relative pb-[11px]'>
              <img src="/assets/services/item6.svg" alt="" />
              <button onClick={() => navigate("/assessment")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] text-[24px] leading-[22px] text-[#FFFFFF] h-[50px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[198px]'>Assessment</button>
            </div>
        <div data-aos="flip-up" className='relative pb-[11px]'>
              <img src="/assets/services/item7.svg" alt="" />
              <button onClick={() => navigate("/lms")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] text-[24px] leading-[22px] text-[#FFFFFF] h-[50px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[198px]'>LMS</button>
            </div>
        </div>
        <div className="flex justify-center">
        <img data-aos="fade-up" src="/assets/services/item8.svg" alt="" />
        </div>
        </div>
        {/* <div className="New-login">
          <div className="New-login-left">
            <div className="flex flex-col gap-[16px]">
              <div className="b1">
                <h2>GISUL</h2>
              </div>
              <div className="b2">
                <h2>Services</h2>
              </div>
            </div>
            <div className='newservices-div'>
              <div className='new-services-card'>
                <img src={img3} />
                <div className='ser-title'>
                  <p>Lateral Hiring</p>

                </div>
              </div>
              <div className='new-services-card'>
                <img src={img3} />
                <div className='ser-title'>
                  <p>Lateral Hiring</p>

                </div>
              </div>
            </div>
            <div className='newservices-div'>
              <div className='new-services-card'>
                <img src={img3} />
                <div className='ser-title'>
                  <p>Lateral Hiring</p>

                </div>
              </div>

            </div>
          </div>


          <div className="New-login-right">
            <div className='newservices-div'>
              <div className='new-services-card'>
                <img src={img3} />
                <div className='ser-title'>
                  <p>Lateral Hiring</p>

                </div>
              </div>
              <div className='new-services-card'>
                <img src={img3} />
                <div className='ser-title'>
                  <p>Lateral Hiring</p>

                </div>
              </div>
            </div>
            <img className='ser-2-img' src={img2} />


          </div>
        </div>
        <br />
        <br /> */}

        <Footer />
      </div>
    </>
  )
}

export default Services2